import React from "react"
import { Box, BoxProps, Heading, Text } from "@chakra-ui/react"
import { useInView } from "react-intersection-observer"
import { Tooltip as ReactTooltip } from "react-tooltip"

import "@app/theme/css/tooltip.css"

const colors = ["offBlue", "blue", "teal", "green", "gold", "red"]

type Props = {
  index: number
  title: string
  tip: string
  strikeStyle: "thick" | "thin" | null
} & BoxProps

const StuffTooltip: React.FC<Props> = ({ index, title, tip, strikeStyle, ...props }) => {
  const [ref, inView] = useInView({
    /* Optional options */
    threshold: 0.5,
  })

  const id = `tip-${title}-${index}`

  return (
    <Box
      sx={{
        ".react-tooltip": {
          textAlign: "center",
          w: { base: "300px", sm: "400px" },
        },
      }}
    >
      <Heading
        ref={ref}
        data-tooltip-id={id}
        data-tooltip-float
        aria-label={title}
        fontWeight={500}
        fontSize={{ base: "25px", sm: "46px" }}
        lineHeight={{ base: 1.4, sm: 1.3 }}
        pos="relative"
        display="inline"
        textDecoration={strikeStyle === "thin" ? "line-through" : "none"}
        cursor="pointer"
        _hover={{ textDecoration: strikeStyle === "thin" ? "line-through" : "none" }}
        _before={
          strikeStyle === "thick"
            ? {
                content: '""',
                pos: "absolute",
                left: "-6px",
                top: "50%",
                h: "4px",
                w: inView ? "calc(100% + 12px)" : 0,
                transitionDelay: "0.5s",
                bgColor: "currentColor",
                transition: "all 0.3s ease-in-out",
              }
            : {}
        }
        {...props}
      >
        {title}
      </Heading>
      <ReactTooltip id={id} opacity={1}>
        <Text variant="text18" display="block" p="30px" borderRadius="50px" bgColor={`brand.${colors?.[index % colors?.length]}`}>
          {tip}
        </Text>
      </ReactTooltip>
    </Box>
  )
}

export default StuffTooltip
